import { FormField } from 'app/form-fields/common/register/form-field';
import { FormFieldColumn } from 'app/form-fields/common/register/form-field-column/form-field-column';
import { FormFieldColumnComponent } from 'app/form-fields/common/register/form-field-column/form-field-column.component';
import { DateColumn } from 'app/form-fields/date/register/date-column';
import { DateColumnComponent } from 'app/form-fields/date/register/date-column.component';
import { DateHeaderColumn } from 'app/form-fields/date/register/date-header-column';
import { TimeFieldColumn } from 'app/form-fields/date/register/time-field-column';
import { SitemateImageUtils } from 'app/shared/service/sitemate-image-utils';

import { LocationColumn } from './location-column/location-column';
import { LocationColumnComponent } from './location-column/location-column.component';
import { UserColumn } from './user-column/user-column';
import { UserColumnComponent } from './user-column/user-column.component';

export class SignonTableRegisterComponent extends FormField {
  constructor(item, header) {
    super(item, header);

    if (!item.entries || !item.entries.length) {
      this.grid = [this.getEmptyRow()];
      return;
    }

    this.grid = item.entries.map((entry, index) => {
      const rowSpan = index === item.entries.length - 1 ? 0 : 1;
      return this.getEntryRow(entry, rowSpan);
    });
  }

  private getEntryRow(entry, rowSpan) {
    const userColumn = new UserColumn({ user: entry.user, rowSpan }, UserColumnComponent);

    const companyColumn = new FormFieldColumn(
      {
        content: entry.user.companyName,
        rowSpan,
      },
      FormFieldColumnComponent,
    );

    const signatureColumn = this.getSignatureColumn(entry, rowSpan);

    const dateColumn = new DateColumn(
      {
        startDate: entry.date,
        rowSpan,
      },
      {} as DateHeaderColumn,
      DateColumnComponent,
    );

    const timeColumn = new TimeFieldColumn(
      {
        value: entry.date,
        rowSpan,
      },
      FormFieldColumnComponent,
    );

    const locationColumn = new LocationColumn(
      {
        point: entry.location,
        rowSpan,
      },
      LocationColumnComponent,
    );

    return [userColumn, companyColumn, signatureColumn, dateColumn, timeColumn, locationColumn];
  }

  private getSignatureColumn(entry, rowSpan) {
    const sitemateImageUtils = new SitemateImageUtils();
    const imgSrc = sitemateImageUtils.getImageVariantUrl(entry.user.signatureUrl, 'small');
    return new FormFieldColumn(
      {
        content: `<img src="${imgSrc}" class="img-fluid" style="min-height: 50px"/>`,
        rowSpan,
      },
      FormFieldColumnComponent,
    );
  }

  private getEmptyRow() {
    return [
      new FormFieldColumn({}, FormFieldColumnComponent),
      new FormFieldColumn({}, FormFieldColumnComponent),
      new FormFieldColumn({}, FormFieldColumnComponent),
      new FormFieldColumn({}, FormFieldColumnComponent),
      new FormFieldColumn({}, FormFieldColumnComponent),
      new FormFieldColumn({}, FormFieldColumnComponent),
    ];
  }
}
